var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
import { useOkapiKy, useStripes } from '@folio/stripes/core';
import { MultiColumnList, Select, RadioButton, RadioButtonGroup, Tooltip, Layout, Headline, Button, Checkbox, Datepicker, Callout, Loading, MessageBanner, IconButton, PaneHeaderIconButton, } from '@folio/stripes/components';
import { RecordType } from '../types/api';
import useOrganizationNames from '../hooks/useOrganizationNames';
import useUserNames from '../hooks/useUserNames';
import useCanSearchUsers from '../hooks/useCanSearchUsers';
import SearchLayout from '../components/SearchLayout';
import { TableLoadingSkeleton, TableRefetchOverlay, TableErrorState, } from '../components/TableStates';
import { ReviewBadge } from '../components/ReviewBadge';
import { OpenProposalBadges } from '../components/OpenProposalBadges';
import { AuthorityTypeLabel, TYPE_NAME_FONT_WEIGHT } from '../components/AuthorityTypeCard';
import { ValidationStatusBadge } from '../components/Validation/ValidationStatusBadge';
import RevalidationProgressBanner from '../components/Validation/RevalidationProgressBanner';
import ListActionsMenu from '../components/ListActions/ListActionsMenu';
import PaneHelpButton from '../components/PaneHelpButton';
import ScreenHelp from '../components/ScreenHelp';
import { AUTHORITIES_HELP } from '../components/screenHelpContent';
import ImportFileModal from '../components/ImportFile/ImportFileModal';
import useRecordList, { RECORDS_QUERY_ROOT } from '../hooks/useRecordList';
import { useVocabularyTypes } from '../hooks/useVocabularyTypes';
import { useSourceSystems } from '../hooks/useSourceSystems';
import { useStartRevalidate, useCurrentRevalidateJob } from '../hooks/useRevalidateJob';
import { getHeaders } from '../api/apiUtils';
import { fetchRecordExport } from '../api/recordService';
import useRecordDetail from '../hooks/useRecordDetail';
import RecordDetail from '../components/RecordDetail/RecordDetail';
import ProposalDetailView from '../components/ProposalDetail/ProposalDetail';
import AuthorityWorkspaceNavigation from '../components/AuthorityWorkspaceNavigation';
import { formatHeadingLabel } from '../utils/formatHeadingLabel';
import { parseExportLimitError } from '../utils/parseExportLimitError';
import { parseFieldQueryError } from '../utils/parseFieldQueryError';
import { isTimeoutError } from '../utils/errorKind';
import { useFieldQueryCatalog } from '../hooks/useFieldQueryCatalog';
import { useFieldQueryLanguage } from '../search/fieldQuery/useFieldQueryLanguage';
import FieldQueryLine from '../components/FieldQueryLine/FieldQueryLine';
import { formatSourceSystem } from '../utils/formatSourceSystem';
import { recordDisplayId } from '../utils/recordDisplayId';
import useAllowedProposalActions from '../hooks/useAllowedProposalActions';
import { NO_ITEM_TO_VIEW } from '../utils/mclNoItemToView';
import { authorityListLayout } from './authorityListLayout';
import { authorityListTypeNames } from './authorityListTypeNames';
import { ID_ON_SCREEN, useWidestTextWidth } from './useWidestTextWidth';
import { idUnbreakableParts } from './idUnbreakableParts';
import css from './AuthoritiesList.css';
var MAX_HEADING_LENGTH = 80;
/** CZNA-1529 — MCL's cells set `word-break: break-word`; an id or a status may wrap only between words. */
var BETWEEN_WORDS = { whiteSpace: 'normal', wordBreak: 'normal', overflowWrap: 'normal' };
var WRAP_ANYWHERE = { overflowWrap: 'anywhere' };
/**
 * Stripes' default (medium) Badge, as it looked here before (stripes-components Badge.css: 22 px
 * high, at least 22 px wide, a full pill, centred bold small text on #f2f2f2, 6 px either side) —
 * except that a second line makes it taller instead of spilling out of a fixed height. On one
 * line 2 + 18 + 2 px is the same 22 px, and an 11 px radius on it the same pill.
 */
var PROPOSAL_STATUS_STYLE = __assign(__assign({}, BETWEEN_WORDS), { display: 'inline-block', boxSizing: 'border-box', minHeight: '22px', minWidth: '22px', padding: '2px 6px', lineHeight: '18px', borderRadius: '11px', textAlign: 'center', backgroundColor: '#f2f2f2', color: 'var(--color-text-p2)', fontSize: 'var(--font-size-small)', fontWeight: 700 });
/**
 * Server-side export ceiling, enforced by RecordServiceImpl.findAllForExport. CZNA-537:
 * whether a given filter is over it is now the server's call (`list.exportable`) — this
 * constant is only the number quoted in the disabled-state hint. The number in the
 * *failure* callout comes from the server's payload instead, so the two cannot drift.
 */
var EXPORT_LIMIT = 10000;
/**
 * Inline autocomplete component for searching and selecting a user (creator filter).
 */
var CreatorAutocomplete = function (_a) {
    var onSelect = _a.onSelect;
    var ky = useOkapiKy();
    var intl = useIntl();
    var _b = useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = useState(''), debouncedTerm = _c[0], setDebouncedTerm = _c[1];
    useEffect(function () {
        var timer = setTimeout(function () { return setDebouncedTerm(searchTerm); }, 300);
        return function () { return clearTimeout(timer); };
    }, [searchTerm]);
    var _d = useQuery(['czna-users-search', debouncedTerm], function () { return ky.get("czna-users/users?query=".concat(encodeURIComponent(debouncedTerm), "&limit=10"), {
        headers: getHeaders(),
    }).json(); }, { enabled: debouncedTerm.length >= 2, keepPreviousData: true }), users = _d.data, isLoading = _d.isLoading;
    return (React.createElement("div", { style: { position: 'relative' } },
        React.createElement("input", { type: "text", value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, placeholder: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.creator.placeholder' }), style: { width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' } }),
        isLoading && debouncedTerm.length >= 2 && (React.createElement(Loading, null)),
        (users === null || users === void 0 ? void 0 : users.items) && users.items.length > 0 && debouncedTerm.length >= 2 && (React.createElement("div", { style: { position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ccc', borderRadius: '0 0 4px 4px', zIndex: 100, maxHeight: '200px', overflow: 'auto' } }, users.items.map(function (user) { return (React.createElement("button", { key: user.id, type: "button", onClick: function () {
                onSelect(user.id, "".concat(user.lastName, ", ").concat(user.firstName));
                setSearchTerm('');
            }, style: { display: 'block', width: '100%', padding: '8px', textAlign: 'left', border: 'none', background: 'none', cursor: 'pointer' }, onMouseEnter: function (e) { e.target.style.backgroundColor = '#f0f0f0'; }, onMouseLeave: function (e) { e.target.style.backgroundColor = 'transparent'; } },
            user.lastName,
            ", ",
            user.firstName)); })))));
};
var AuthoritiesList = function (_a) {
    var _b, _c, _d, _f, _g, _h;
    var match = _a.match, selectedId = _a.selectedId, selectedProposalId = _a.selectedProposalId;
    var intl = useIntl();
    var history = useHistory();
    var location = useLocation();
    var ky = useOkapiKy();
    // CZNA-791 — a cataloguer may not search users; see the hook for why not `hasPerm`.
    var canSearchUsers = useCanSearchUsers().canSearchUsers;
    var vocabularyTypes = useVocabularyTypes().vocabularyTypes;
    var authorityTypeOptions = useMemo(function () { return Object.values(RecordType).map(function (type) { return ({
        value: type,
        label: intl.formatMessage({ id: "ui-czna-authorities.recordType.".concat(type) }),
    }); }); }, [intl]);
    var vocabularyTypeOptions = useMemo(function () { return vocabularyTypes.map(function (vt) { return ({
        value: vt.code,
        label: vt.labelCs || vt.code,
    }); }); }, [vocabularyTypes]);
    // CZNA-217 — the query line over fields and subfields. CZNA-1443: it is opened from the
    // search pane and closed with its own ×; an applied query outlives the editor as a chip
    // above the results, which is also what a shared link (`?fq=`) lands on. The field
    // catalog is fetched once the query is in use (the chip's query compiles against it
    // too) and then stays cached.
    var _j = useState(false), fieldQueryOpen = _j[0], setFieldQueryOpen = _j[1];
    var _k = useState(function () { return new URLSearchParams(location.search).has('fq'); }), fieldQueryInUse = _k[0], setFieldQueryInUse = _k[1];
    var fieldQueryRecordTypes = useMemo(function () { return __spreadArray(__spreadArray([], authorityTypeOptions, true), vocabularyTypeOptions, true).map(function (option) { return ({ code: option.value, label: option.label }); }); }, [authorityTypeOptions, vocabularyTypeOptions]);
    var fieldQueryCatalog = useFieldQueryCatalog(fieldQueryOpen || fieldQueryInUse);
    var fieldQueryLanguage = useFieldQueryLanguage(fieldQueryCatalog.catalog, fieldQueryRecordTypes);
    var compileFieldQuery = useMemo(function () { return (fieldQueryLanguage
        ? function (text, matchCase) {
            var compiled = fieldQueryLanguage.compileText(text, matchCase);
            return { tree: compiled.tree ? JSON.stringify(compiled.tree) : undefined, hasErrors: compiled.hasErrors };
        }
        : undefined); }, [fieldQueryLanguage]);
    var list = useRecordList({ compileFieldQuery: compileFieldQuery });
    /**
     * CZNA-217 — a refused field query gets its own message: the 504 says the database
     * stopped it and how to narrow it, the 400 that the server rejected it. Read
     * asynchronously (the body is a stream), so it is state, not a derivation.
     */
    var _l = useState(null), fieldQueryError = _l[0], setFieldQueryError = _l[1];
    var fieldQueryApplied = ((_b = list.appliedFilterParams) === null || _b === void 0 ? void 0 : _b.fieldQuery) !== undefined;
    useEffect(function () {
        var live = true;
        setFieldQueryError(null);
        if (list.error) {
            parseFieldQueryError(list.error, fieldQueryApplied).then(function (parsed) {
                if (live)
                    setFieldQueryError(parsed);
            });
        }
        return function () {
            live = false;
        };
    }, [list.error, fieldQueryApplied]);
    var fieldQueryOpenerRef = useRef(null);
    var fieldQueryEditRef = useRef(null);
    // The control that closed the editor or the chip is gone after the render, so focus
    // moves on to what replaced it: the chip's "Upravit", or the opener in the search pane.
    var _m = useState(false), refocusFieldQuery = _m[0], setRefocusFieldQuery = _m[1];
    useEffect(function () {
        var _a, _b;
        if (refocusFieldQuery) {
            setRefocusFieldQuery(false);
            (_b = ((_a = fieldQueryEditRef.current) !== null && _a !== void 0 ? _a : fieldQueryOpenerRef.current)) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [refocusFieldQuery]);
    var openFieldQuery = function () {
        setFieldQueryInUse(true);
        setFieldQueryOpen(true);
    };
    // Closing keeps what was applied — the chip shows it — and drops an unsubmitted draft
    // (text and match case), so "Upravit" reopens the query that is actually narrowing the
    // list and a later plain search does not apply a draft nobody submitted.
    var closeFieldQuery = function () {
        list.setFieldQueryText(list.appliedFieldQueryText);
        list.setFieldQueryMatchCase(list.appliedFieldQueryMatchCase);
        setFieldQueryOpen(false);
        setRefocusFieldQuery(true);
    };
    var removeFieldQuery = function () {
        list.submitFieldQuery('');
        setFieldQueryOpen(false);
        setRefocusFieldQuery(true);
    };
    var canCreateProposal = useAllowedProposalActions().canCreateProposal;
    var _o = useState(false), isExporting = _o[0], setIsExporting = _o[1];
    var queryClient = useQueryClient();
    var stripes = useStripes();
    // CZNA-1106 — the same permission the Importy screen checks before its NK download.
    var canImport = stripes.hasPerm('czna-authorities.import.execute');
    // CZNA-1511 — a revalidation run is the authority admin's, from starting it to watching it.
    // Not `revalidate.read`: a cataloguer holds that for the record form. Kvalita korpusu
    // gates its run buttons on the same permission.
    var canRevalidate = stripes.hasPerm('czna-authorities.validation.revalidate.execute');
    var _p = useState(false), importOpen = _p[0], setImportOpen = _p[1];
    // CZNA-298 — the alphabetical register ("Rejstřík") moved out of this list into
    // the standalone /headings page. Redirect legacy `?mode=index` bookmarks (incl.
    // CZNA-230 links carrying `?indexType=`) to the new route, preserving indexType.
    useEffect(function () {
        var params = new URLSearchParams(location.search);
        if (params.get('mode') !== 'index')
            return;
        var indexType = params.get('indexType');
        var headingsPath = "".concat(match.path.replace(/\/[^/]*$/, ''), "/headings");
        history.replace(indexType ? "".concat(headingsPath, "?indexType=").concat(indexType) : headingsPath);
    }, [location.search, match.path, history]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var calloutRef = React.useRef(null);
    // One-shot success toast after direct-edit save (TASK-070, AR-02 A1).
    // RecordEdit redirects via `history.push(detailUrl, { savedToast: true })`.
    // We emit once on mount/state-change, then clear the flag with history.replace
    // so a refresh or back/forward navigation doesn't re-fire the callout.
    useEffect(function () {
        var _a, _b;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.savedToast) {
            (_b = calloutRef.current) === null || _b === void 0 ? void 0 : _b.sendCallout({
                type: 'success',
                message: intl.formatMessage({ id: 'ui-czna-authorities.record.edit.saveSuccess' }),
            });
            history.replace(__assign(__assign({}, location), { state: undefined }));
        }
    }, [location, history, intl]);
    var handleRowClick = useCallback(function (_e, row) {
        // CZNA-974 — a PROPOSAL row from the combined search has no `/records/:id` detail of
        // its own. CZNA-1190: it opens here, next to the same result list, whatever its status —
        // it used to go through `proposalPath`, which sent a pending proposal to Ke kontrole and
        // the others to a different tab, dropping the search either way.
        if (row.kind === 'PROPOSAL') {
            history.push("".concat(match.path, "/proposals/").concat(row.id));
            return;
        }
        history.push("".concat(match.path, "/").concat(row.id));
    }, [match.path, history]);
    var showMergedIntoColumn = list.statusFilter === 'merged' || list.statusFilter === 'all';
    // CZNA-974 / CZNA-1441 — a PROPOSAL row shows its library and, under it, its author in
    // the "Autor" column (see resultsFormatter below), so both lookups are needed.
    var getOrganizationName = useOrganizationNames().getOrganizationName;
    var proposalAuthorIds = useMemo(function () { return list.items.filter(function (item) { return item.kind === 'PROPOSAL'; }).map(function (item) { return item.createdBy; }); }, [list.items]);
    var getUserName = useUserNames(proposalAuthorIds).getUserName;
    // CZNA-1503 — what the "Autor" cell renders is part of the row's data, not something the
    // formatter looks up on the side. MCL measures a row's height once and re-measures only
    // when `contentData` changes, while the names arrive in their own request after the rows:
    // looked up on the side, a row measured without its name keeps that height once the name
    // wraps onto two or three lines, and the next row is drawn over it. MCL also detects a
    // change by sampling (every 4th row and the last one, `dataChangedOrLess`), so a name on
    // its own proposal row alone would go unnoticed on most rows — every row therefore carries
    // the page's resolved names too, and their arrival changes the first row MCL compares.
    // The library falls back to an organization name, which is looked up the same way.
    var tableItems = useMemo(function () {
        var rows = list.items.map(function (item) { return (item.kind === 'PROPOSAL'
            ? __assign(__assign({}, item), { proposalLibrary: item.catalogingAgency || getOrganizationName(item.organizationId) || '—', proposalAuthorName: getUserName(item.createdBy) }) : item); });
        var resolved = rows
            .map(function (row) { var _a; return ('proposalLibrary' in row ? "".concat(row.proposalLibrary, "\t").concat((_a = row.proposalAuthorName) !== null && _a !== void 0 ? _a : '') : ''); })
            .join('\n');
        return rows.map(function (row) { return (__assign(__assign({}, row), { resolved: resolved })); });
    }, [list.items, getOrganizationName, getUserName]);
    // CZNA-791 — a creator filter restored from `?createdBy=` carries only the id; the
    // name is known only when it was picked in the autocomplete. Resolved through the
    // name endpoint every user may read, so a cataloguer's chip is not blank either.
    var creatorIds = useMemo(function () { return [list.createdByUserId]; }, [list.createdByUserId]);
    var getCreatorName = useUserNames(creatorIds).getUserName;
    var creatorLabel = list.createdByUserName
        || getCreatorName(list.createdByUserId)
        || list.createdByUserId;
    // CZNA-1529 — the size of the results list, for sizing its columns (authorityListLayout) and
    // MCL itself. The wrapper comes and goes with the loading and empty states, so it is observed
    // from a callback ref rather than an effect (as the register does, CZNA-1513).
    //
    // MCL is given this width and height rather than measuring them with its own AutoSizer: the
    // AutoSizer reports a new width one render before the list hands over the columns for it, MCL
    // re-derives its widths from the OLD columns in between, and when the new ones arrive with a
    // different column count it merges the two and keeps the old (MCLRenderer componentDidUpdate).
    // In Chromium at 1280 with a detail open that drew the shares of an unmeasured list at 337 px —
    // the type's marker cut in half, a 50 px id in four lines. Width and columns now change in one
    // render, where MCL replaces its widths wholesale (getDerivedStateFromProps).
    var _q = useState(), listSize = _q[0], setListSize = _q[1];
    var listWidth = listSize === null || listSize === void 0 ? void 0 : listSize.width;
    var resizeObserverRef = useRef(null);
    var listNodeRef = useRef(null);
    var setListNode = useCallback(function (node) {
        var _a;
        listNodeRef.current = node;
        (_a = resizeObserverRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        resizeObserverRef.current = null;
        if (!node || typeof ResizeObserver === 'undefined')
            return;
        resizeObserverRef.current = new ResizeObserver(function (_a) {
            var entry = _a[0];
            setListSize({
                width: Math.floor(entry.contentRect.width),
                height: Math.floor(entry.contentRect.height) || undefined,
            });
        });
        resizeObserverRef.current.observe(node);
    }, []);
    // CZNA-1529 — the type column names the type only where it holds the widest name the list
    // can show: every authority type, every vocabulary type of the registry (the type filter offers
    // them) and any other type a row on this page has, each as AuthorityTypeLabel names it in this
    // locale — measured in the cell's font, not assumed ("Město pro staré tisky" outgrew a
    // constant sized for "Formální deskriptor" and was cut off at 1920 px).
    var typeNames = useMemo(function () { return authorityListTypeNames(intl, vocabularyTypes.map(function (vt) { return vt.code; }), tableItems.map(function (row) { return row.type; })); }, [intl, vocabularyTypes, tableItems]);
    var getListNode = useCallback(function () { return listNodeRef.current; }, []);
    var typeNameWidth = useWidestTextWidth(getListNode, typeNames, TYPE_NAME_FONT_WEIGHT, "".concat(listWidth, ":").concat(tableItems.length > 0));
    // DB-295 — the id column likewise holds the widest id on this page, measured in the id
    // cell's font: ids of one length are not one width ("Oaun2026056278" overran a column sized
    // for "Ojo20260507101" by 2 px at 1280). Measured by the parts that cannot break: the cell
    // may break a test id after a hyphen, and a column sized for the whole of
    // "czna386cp4-y4roup-01" pushed the type names out at 1920 (gate-55167df3a).
    var ids = useMemo(function () { return tableItems.flatMap(function (row) { return __spreadArray([
        recordDisplayId(row)
    ], (showMergedIntoColumn && row.mergedIntoAuthorityId ? [recordDisplayId({
            type: row.type, exportId: row.mergedIntoExportId, authorityId: row.mergedIntoAuthorityId,
        })] : []), true); }).filter(function (id) { return !!id; }).flatMap(idUnbreakableParts); }, [tableItems, showMergedIntoColumn]);
    var idWidth = useWidestTextWidth(getListNode, ids, undefined, "".concat(listWidth, ":").concat(tableItems.length > 0), ID_ON_SCREEN);
    var _r = useMemo(function () { return authorityListLayout(listWidth, showMergedIntoColumn, typeNameWidth, idWidth); }, [listWidth, showMergedIntoColumn, typeNameWidth, idWidth]), typeIconOnly = _r.typeIconOnly, squeezed = _r.squeezed, visibleColumns = _r.visibleColumns, columnWidths = _r.columnWidths;
    // CZNA-1529 — a new layout makes MCL mount every row anew (mclColumnChange.test), so the row a
    // keyboard user stands on is replaced: Enter on it opens the detail, the list narrows, and
    // focus fell to <body>. The record of a row focused FROM THE KEYBOARD is remembered (by id: the
    // rows may have moved) and, once the new layout is on screen, focus goes back to its row — or,
    // if that row is no longer rendered, to the list itself. A row focused by a click is not: put
    // back by script it would draw MCL's focus ring on a row the user only clicked. Focus landing
    // anywhere outside the list forgets the row, so focus that moved on (into the opened detail)
    // is never dragged back, not even by a later resize.
    var tableItemsRef = useRef(tableItems);
    tableItemsRef.current = tableItems;
    var focusedRowIdRef = useRef(null);
    useEffect(function () {
        var fromKeyboard = false;
        var onKeyDown = function () { fromKeyboard = true; };
        var onPointerDown = function () {
            fromKeyboard = false;
            focusedRowIdRef.current = null;
        };
        var onFocusIn = function (e) {
            var _a, _b;
            var list = listNodeRef.current;
            var target = e.target instanceof Element ? e.target : null;
            var row = target && (list === null || list === void 0 ? void 0 : list.contains(target)) ? target.closest('[data-row-inner]') : null;
            focusedRowIdRef.current = row && fromKeyboard
                ? (_b = (_a = tableItemsRef.current[Number(row.getAttribute('data-row-inner'))]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null
                : null;
        };
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('focusin', onFocusIn, true);
        return function () {
            document.removeEventListener('keydown', onKeyDown, true);
            document.removeEventListener('pointerdown', onPointerDown, true);
            document.removeEventListener('focusin', onFocusIn, true);
        };
    }, []);
    useEffect(function () {
        if (!focusedRowIdRef.current)
            return undefined;
        var frame = requestAnimationFrame(function () {
            var id = focusedRowIdRef.current;
            var list = listNodeRef.current;
            var active = document.activeElement;
            if (!id || !list || (active && active !== document.body && active.isConnected))
                return;
            // One shot: this layout change is the one the row was remembered for. Focusing the row
            // remembers it again (the user is still on it, from the keyboard).
            focusedRowIdRef.current = null;
            var index = tableItemsRef.current.findIndex(function (item) { return item.id === id; });
            var row = index >= 0 ? list.querySelector("[data-row-inner=\"".concat(index, "\"]")) : null;
            (row !== null && row !== void 0 ? row : list).focus();
        });
        return function () { return cancelAnimationFrame(frame); };
    }, [visibleColumns, columnWidths]);
    var resultsFormatter = useMemo(function () { return (__assign({ validation: function (record) {
            var _a, _b, _c;
            // CZNA-974 — a PROPOSAL row has no validation state of its own (records/proposals
            // are validated independently, and a proposal's own status is more relevant here
            // than "not yet validated"); show its workflow status instead.
            // CZNA-1529 — a status wraps between its words and its badge grows with it: Stripes'
            // Badge is a fixed 22 px pill, and "Ke schválení / v NK" on two lines spilled out of it
            // into the next row. Never inside a word (MCL's cells break words anywhere): Stav is as
            // wide as the widest status word in any translation (authorityListLayout).
            if (record.kind === 'PROPOSAL') {
                return record.proposalStatus ? (React.createElement("span", { "data-testid": "proposal-status", style: PROPOSAL_STATUS_STYLE },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.proposalStatus.".concat(record.proposalStatus) }))) : null;
            }
            // CZNA-1512 — the review stage sits here, under the validation result, not appended to
            // the heading: there it moved with the heading's length and read as the same badge as
            // "Návrh" on the other side of the text. A proposal row carries no reviewStatus.
            return (React.createElement("span", { "data-testid": "record-status", style: __assign({ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px' }, BETWEEN_WORDS) },
                React.createElement(ValidationStatusBadge, { status: (_a = record.validationStatus) !== null && _a !== void 0 ? _a : 'NOT_VALIDATED', title: record.validationStatus === 'HAS_ERRORS'
                        ? intl.formatMessage({ id: 'ui-czna-authorities.validation.tooltip.errors' }, { count: (_b = record.validationErrorCount) !== null && _b !== void 0 ? _b : 0 })
                        : record.validationStatus === 'HAS_WARNINGS_ONLY'
                            ? intl.formatMessage({ id: 'ui-czna-authorities.validation.tooltip.warnings' }, { count: (_c = record.validationWarningCount) !== null && _c !== void 0 ? _c : 0 })
                            : undefined }),
                React.createElement(ReviewBadge, { reviewStatus: record.reviewStatus, standalone: true }),
                React.createElement(OpenProposalBadges, { proposals: record.openProposals, wrapWords: true })));
        }, 
        // CZNA-977: the "ID autority" column shows the national control number (MARC 001).
        // VOCABULARY_* rows — which this list does show, they are in the type filter — keep
        // their authority id; recordDisplayId is the single place that decision is taken.
        // CZNA-1529 — a control number is one token and never breaks inside ("Oph202604958|1" at
        // 1280 px); the column fits it. A longer id seeded by a test ("EXP-AR08-REFERRER") breaks
        // only after a hyphen, rather than be cut off. In a list squeezed below its columns' words
        // an id wraps wherever it must, for the same reason.
        authorityId: function (record) { return (React.createElement("span", { "data-authority-id": true, style: squeezed ? WRAP_ANYWHERE : BETWEEN_WORDS }, recordDisplayId(record))); }, headingValue: function (record) {
            // TASK-162 — when the search matched a VARIANT heading, append the cataloging-style
            // "viz" cross-reference: "{preferred} (varianta: {matched})". Truncation applies to
            // the COMPOSITE (so a long variant suffix is also collapsed under the tooltip),
            // mirroring how the user expects the same MAX_HEADING_LENGTH rule across both
            // PREFERRED-only and composite labels. The tooltip shows the full untruncated text.
            var label = formatHeadingLabel(record, intl);
            var renderHeading = function () {
                if (label.length <= MAX_HEADING_LENGTH) {
                    return label;
                }
                var truncated = "".concat(label.slice(0, MAX_HEADING_LENGTH), "...");
                return (React.createElement(Tooltip, { text: label, id: "heading-tooltip-".concat(record.id) }, function (tooltip) { return (React.createElement("span", { ref: tooltip.ref, "aria-labelledby": tooltip.ariaIds.text }, truncated)); }));
            };
            return (React.createElement("span", null,
                record.kind === 'PROPOSAL' && (React.createElement("span", { "data-testid": "record-kind-proposal-badge", style: {
                        display: 'inline-block',
                        marginRight: '6px',
                        padding: '2px 6px',
                        fontSize: '0.85em',
                        fontWeight: 500,
                        borderRadius: '4px',
                        backgroundColor: '#e8eaf6',
                        border: '1px solid #9fa8da',
                        color: '#283593',
                    } },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.kind.proposal" }))),
                renderHeading()));
        }, 
        // CZNA-1529 — the name never breaks mid-word: where the column is too narrow for it, the
        // marker alone with the name as its tooltip and accessible name; otherwise on one line.
        type: function (record) { return (React.createElement(AuthorityTypeLabel, { type: record.type, iconOnly: typeIconOnly, singleLine: !typeIconOnly })); }, 
        // CZNA-1441 — the library that created the item: its 040 $a exactly as stored (a sigla,
        // or free text such as "Jaroslav Kunc"), the same value CZNA-1421's queue facet filters
        // by. Never resolved to an organization name: there are no organizations for siglas yet.
        // A PROPOSAL row adds its author's name underneath — it is the only place the list shows
        // who wrote a proposal — and falls back to the owning library when its own data has no
        // 040 $a yet, so the row loses nothing the old "Zdrojový systém" column showed.
        // An id that does not resolve (a deleted user, a library not loaded) is never shown in
        // its place: a UUID tells the reader nothing, so the library becomes "—" and the author
        // line is left out.
        author: function (record) {
            if (record.kind !== 'PROPOSAL') {
                return record.catalogingAgency || '—';
            }
            var library = record.proposalLibrary;
            var authorName = record.proposalAuthorName;
            return (React.createElement("span", null,
                React.createElement("span", null, library),
                authorName && (React.createElement("span", { "data-testid": "record-proposal-author", style: { display: 'block', fontSize: '0.85em', color: '#555' } }, authorName))));
        }, updatedAt: function (record) {
            if (!record.updatedAt)
                return '';
            var date = intl.formatDate(record.updatedAt, { day: '2-digit', month: '2-digit', year: 'numeric' });
            var time = intl.formatTime(record.updatedAt, { hour: '2-digit', minute: '2-digit' });
            return "".concat(date, " ").concat(time);
        } }, (showMergedIntoColumn ? {
        mergedIntoAuthorityId: function (record) {
            return record.mergedIntoAuthorityId ? (React.createElement("button", { type: "button", onClick: function (e) {
                    e.stopPropagation();
                    history.push("".concat(match.path, "?mergedTarget=").concat(record.mergedIntoAuthorityId));
                }, style: __assign({ background: 'none', border: 'none', color: '#008', cursor: 'pointer', padding: 0, textDecoration: 'underline', textAlign: 'left' }, (squeezed ? WRAP_ANYWHERE : BETWEEN_WORDS)) }, recordDisplayId({
                type: record.type,
                exportId: record.mergedIntoExportId,
                authorityId: record.mergedIntoAuthorityId,
            }))) : null;
        },
    } : {}))); }, [showMergedIntoColumn, typeIconOnly, squeezed, intl, match.path, history]);
    // CZNA-1441 — ordered by how a cataloguer scans the list: the type icon first, validation
    // last. "Zdrojový systém" and "Verze" left the table (decided 22. 10. 2026 over a screenshot);
    // the source-system FILTER stays in the panel. The order and which columns fit (CZNA-1529,
    // decided 31. 10. 2026: "Autor" and "Aktualizováno" make way beside an open detail) are
    // authorityListLayout's.
    /**
     * Type filter options: the authority types (enum) followed by the vocabulary
     * types (registry).
     *
     * <p>CZNA-457: this used to be `Object.values(RecordType)` alone, back when
     * the FE enum still carried 12 hardcoded `VOCABULARY_*` members. Those
     * members were dead — the backend deleted them in CZNA-392/393/397 — but the
     * dropdown was the one place they still did something, so simply dropping
     * them from the enum would have silently removed vocabulary filtering from
     * this screen. Reading the registry instead both restores it and fixes it:
     * the hardcoded list offered 12 of the ~27 registered types and missed
     * VOCABULARY_LANGUAGE, VOCABULARY_NAME_FORM, VOCABULARY_CONTROL and
     * VOCABULARY_GEOGRAPHIC_CODE, which had translations but no enum member.
     *
     * <p>Registry labels come from the row's own `labelCs`, not from a
     * `recordType.*` message: a type added through the admin GUI has no
     * translation key, and falling back to the raw code is better than rendering
     * the key. The list degrades to the authority types alone while the registry
     * query is in flight or if it fails.
     *
     * <p>CZNA-509: the two are kept in ONE filter — a vocabulary entry really is
     * an authority of another type, and splitting the control would imply they
     * are searched differently — but they are rendered as separate `<optgroup>`s
     * so the difference is visible without domain knowledge. `<optgroup>` rather
     * than colour or an inserted "—— Slovníky ——" pseudo-option: the browser
     * indents and emphasises the group natively, screen readers announce the
     * group name with the option, and there is no selectable non-value to guard
     * against. NK asked for this at the 2026-08-07 review.
     */
    /** Flat, in render order — the selected-filter chip resolves its label from here. */
    var typeOptions = useMemo(function () { return __spreadArray(__spreadArray([
        { value: '', label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.type.all' }) }
    ], authorityTypeOptions, true), vocabularyTypeOptions, true); }, [intl, authorityTypeOptions, vocabularyTypeOptions]);
    /**
     * Source-system filter options: "all" plus whatever the corpus holds.
     *
     * <p>DB-061: this used to be a hardcoded `['LOCAL','NKCR','LCNACO','VIAF','OTHER']`,
     * the same defect CZNA-457 fixed on the type filter next door. Measured over the
     * 1 295 924-record corpus it offered LCNACO, VIAF and OTHER, which no record carries,
     * and omitted ALEPH (1 292 908 records), DERIVED and SEED — so "show me only the
     * records from Aleph" was not expressible through this control at all. The list now
     * comes from the server, so it cannot drift from the data and a source system a new
     * import introduces shows up on its own.
     *
     * <p>The facet is scoped by the APPLIED type filter, the same predicate the grid is
     * running. Unscoped it would offer values the grid cannot show: DERIVED (1 549
     * records) and SEED (743) sit exclusively on `VOCABULARY_*` records, which the
     * default list view excludes, so picking DERIVED would produce an empty grid — a new
     * instance of the defect this change removes. The applied filter, not the pending
     * one: the offering has to describe what is on screen, not a selection the user is
     * midway through making.
     *
     * <p>The applied value is merged in when the catalog does not carry it. This Select
     * is controlled by `list.sourceSystemFilter`, which can arrive by deep link
     * (`?sourceSystem=ALEPH`) and is present while the query is still in flight or after
     * it failed. A controlled `<select>` whose value is not among its options silently
     * displays a different one, so without this the user would read "Všechny" over a
     * filtered grid and have no way to clear the filter.
     */
    var sourceSystems = useSourceSystems((_c = list.appliedTypeFilter) !== null && _c !== void 0 ? _c : undefined).sourceSystems;
    var sourceSystemOptions = useMemo(function () {
        var applied = list.sourceSystemFilter;
        var codes = applied && !sourceSystems.includes(applied)
            ? __spreadArray(__spreadArray([], sourceSystems, true), [applied], false).sort()
            : sourceSystems;
        return __spreadArray([
            { value: '', label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.sourceSystem.all' }) }
        ], codes.map(function (sys) { return ({
            value: sys,
            label: formatSourceSystem(sys),
        }); }), true);
    }, [intl, sourceSystems, list.sourceSystemFilter]);
    var handleExport = useCallback(function (format) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1, limitError, fieldQueryError_1, _a;
        var _b, _c, _d, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    setIsExporting(true);
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, 8, 9]);
                    return [4 /*yield*/, fetchRecordExport(ky, list.appliedFilterParams, format)];
                case 2:
                    _g.sent();
                    return [3 /*break*/, 9];
                case 3:
                    err_1 = _g.sent();
                    return [4 /*yield*/, parseExportLimitError(err_1)];
                case 4:
                    limitError = _g.sent();
                    if (!limitError) return [3 /*break*/, 5];
                    _a = null;
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, parseFieldQueryError(err_1, Boolean((_b = list.appliedFilterParams) === null || _b === void 0 ? void 0 : _b.fieldQuery))];
                case 6:
                    _a = _g.sent();
                    _g.label = 7;
                case 7:
                    fieldQueryError_1 = _a;
                    if (fieldQueryError_1) {
                        (_c = calloutRef.current) === null || _c === void 0 ? void 0 : _c.sendCallout({
                            type: 'error',
                            timeout: 0,
                            message: fieldQueryError_1.kind === 'timeout'
                                ? intl.formatMessage({ id: 'ui-czna-authorities.fieldQuery.error.timeout.subtext' }, { seconds: fieldQueryError_1.seconds })
                                : (_d = fieldQueryError_1.message) !== null && _d !== void 0 ? _d : intl.formatMessage({ id: 'ui-czna-authorities.fieldQuery.error.invalid.heading' }),
                        });
                        return [2 /*return*/];
                    }
                    (_f = calloutRef.current) === null || _f === void 0 ? void 0 : _f.sendCallout(limitError
                        ? {
                            type: 'error',
                            timeout: 0,
                            message: intl.formatMessage({ id: 'ui-czna-authorities.authorities.export.limitExceeded' }, { limit: limitError.limit }),
                        }
                        : {
                            type: 'error',
                            message: intl.formatMessage({ id: 'ui-czna-authorities.authorities.export.error' }),
                        });
                    return [3 /*break*/, 9];
                case 8:
                    setIsExporting(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [ky, list.appliedFilterParams, intl]);
    var currentJob = useCurrentRevalidateJob({ enabled: canRevalidate }).data;
    var startRevalidate = useStartRevalidate({
        onSuccess: function () {
            var _a;
            (_a = calloutRef.current) === null || _a === void 0 ? void 0 : _a.sendCallout({
                type: 'success',
                message: intl.formatMessage({ id: 'ui-czna-authorities.listActions.revalidate.started' }),
            });
        },
        onError: function (err) {
            var _a, _b;
            // 409 Conflict — another job is already running. Backend body carries
            // the existing job id, but the polling hook will pick it up on the
            // next tick anyway, so we just surface a generic info callout here.
            var status = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status;
            // CZNA-1625 — no answer in time: the job may have started; never say "failed to start".
            var msgId = isTimeoutError(err)
                ? 'ui-czna-authorities.error.timeout'
                : status === 409
                    ? 'ui-czna-authorities.listActions.revalidate.alreadyRunning'
                    : 'ui-czna-authorities.listActions.revalidate.startFailed';
            (_b = calloutRef.current) === null || _b === void 0 ? void 0 : _b.sendCallout({
                type: status === 409 ? 'warning' : 'error',
                message: intl.formatMessage({ id: msgId }),
            });
        },
    });
    // CZNA-533 stopped the pre-check firing on a count nobody had measured — correct, but it
    // left the action with nothing to check against. `list.totalRecords` is null above the
    // 1000 display cap, so `totalRecords > EXPORT_LIMIT` could never be true: with the cap at
    // 1000 and the ceiling at 10 000 the two windows do not overlap, and for every type above
    // 1000 records Export CSV was offered, clickable, and (above 10 000) certain to fail.
    //
    // CZNA-537 gives the check something real: `list.exportable` is the server's own answer
    // for these exact filters, measured against the ceiling it enforces. Three states —
    // false blocks, true allows, null means not-yet-known and must not block, because a
    // spinner-shaped "no" on a filter that would export fine is the same lie in reverse.
    var tooManyToExport = list.exportable === false;
    // ...but only once we know there is nothing. While the first page is in flight, or
    // after the query failed, an empty `items` is absence of data, not absence of records —
    // saying "nothing matches your selection" there is the same unfounded claim this ticket
    // is about, just pointed at a different unknown.
    var nothingToExport = !list.isLoading && !list.error && list.items.length === 0;
    // CZNA-628 — `list.queryTooShort` is a disabling condition in its own right, not only a
    // reason. It happens to imply `nothingToExport` today (the request is never issued, so
    // `items` is empty), but that is a derivation about absent data, and the button must not
    // depend on it: if it ever came back, Export would fire a request the API answers with 400.
    var exportDisabled = tooManyToExport || list.queryTooShort || list.fieldQueryBlocked
        || nothingToExport || isExporting;
    // Every disabling condition that is not transient gets a sentence. `isExporting` is
    // deliberately left without one — it lasts as long as the click and explains itself.
    var exportDisabledReason;
    if (tooManyToExport) {
        exportDisabledReason = intl.formatMessage({ id: 'ui-czna-authorities.authorities.export.tooMany' }, { limit: EXPORT_LIMIT });
    }
    else if (list.queryTooShort) {
        // CZNA-628 — same reason the list shows the hint: there is no result set, because the
        // search was never run. "Nothing to export" would report that as a fact about the corpus.
        exportDisabledReason = intl.formatMessage({ id: 'ui-czna-authorities.authorities.search.tooShort.heading' });
    }
    else if (nothingToExport) {
        exportDisabledReason = intl.formatMessage({ id: 'ui-czna-authorities.authorities.export.nothingToExport' });
    }
    // CZNA-1106 — the import runs asynchronously, like the NK download: the list
    // cannot show its result yet, so the callout points to where progress is.
    var handleImported = function (batchId, preview) {
        var _a;
        queryClient.invalidateQueries(['czna-import-batches']);
        queryClient.invalidateQueries(['czna-import-active']);
        (_a = calloutRef.current) === null || _a === void 0 ? void 0 : _a.sendCallout({
            type: 'success',
            timeout: 0,
            message: (React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.started", values: {
                    updated: preview.updatedCount,
                    created: preview.newCount,
                    link: function (chunks) { return (React.createElement(Link, { to: "/czna-authorities/import/".concat(batchId) }, chunks)); },
                } })),
        });
    };
    // CZNA-402 — one item per format, sharing every gate the single Export item had. CSV
    // stays first and unchanged: it is what this action has always downloaded, and the
    // ceiling, the short-query guard and the empty-result guard are properties of the
    // SELECTION, which both formats make identically on the server.
    var listActions = __spreadArray(__spreadArray([
        {
            key: 'export',
            format: 'CSV',
            onClick: function () { return handleExport('CSV'); },
            count: list.totalRecords,
            disabled: exportDisabled,
            disabledReason: exportDisabledReason,
        },
        {
            key: 'export',
            format: 'MARCXML',
            onClick: function () { return handleExport('MARCXML'); },
            count: list.totalRecords,
            disabled: exportDisabled,
            disabledReason: exportDisabledReason,
        }
    ], (canImport ? [{
            key: 'import',
            onClick: function () { return setImportOpen(true); },
        }] : []), true), (list.typeFilter && canRevalidate ? [{
            key: 'revalidate-type',
            // CZNA-457: no cast any more. validation.ts's `RecordType` is now
            // defined as the api.ts enum union the vocabulary registry codes, which
            // is exactly what the filter holds — the `as unknown as` that used to sit
            // here was bridging two hand-maintained lists that had both gone stale.
            onClick: function () { return startRevalidate.mutate({
                scope: 'TYPE',
                recordType: list.typeFilter,
            }); },
            recordType: list.typeFilter,
            // The label the user picked in the dropdown — resolved here because
            // registry-driven vocabulary types have no translation key (CZNA-457).
            recordTypeLabel: (_f = (_d = typeOptions.find(function (o) { return o.value === list.typeFilter; })) === null || _d === void 0 ? void 0 : _d.label) !== null && _f !== void 0 ? _f : list.typeFilter,
        }] : []), true);
    var lastMenu = (React.createElement(React.Fragment, null,
        React.createElement(PaneHelpButton, null,
            React.createElement(ScreenHelp, { spec: AUTHORITIES_HELP })),
        React.createElement(ListActionsMenu, { id: "authorities-list-actions", actions: listActions, activeJob: currentJob !== null && currentJob !== void 0 ? currentJob : null }),
        canCreateProposal ? (React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, onClick: function () { return history.push('/czna-authorities/authorities/new'); } },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.new" }))) : null));
    // CZNA-301 — the "jump to heading" control now lives on the Záhlaví (rejstřík)
    // register page, whose search box anchors the keyset browse over PREFERRED +
    // VARIANT headings. The authority records list keeps only column sorting by the
    // preferred heading (click the "Preferované záhlaví" header).
    var filterContent = (React.createElement("div", { className: css.filterPanel },
        React.createElement("div", { className: css.filterRow },
            React.createElement("span", { className: css.filterLabel }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.type' })),
            React.createElement("div", { className: css.filterControl },
                React.createElement(Select, { fullWidth: true, "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.type' }), value: list.typeFilter || '', onChange: function (e) {
                        return list.handleTypeFilterChange(e.target.value || null);
                    } }, __spreadArray([
                    // "Všechny" spans both groups, so it sits outside them.
                    React.createElement("option", { key: "all", value: "" }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.type.all' })),
                    React.createElement("optgroup", { key: "authorities", label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.type.group.authorities' }) }, authorityTypeOptions.map(function (o) { return (React.createElement("option", { key: o.value, value: o.value }, o.label)); }))
                ], (vocabularyTypeOptions.length > 0 ? [
                    React.createElement("optgroup", { key: "vocabularies", label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.type.group.vocabularies' }) }, vocabularyTypeOptions.map(function (o) { return (React.createElement("option", { key: o.value, value: o.value }, o.label)); })),
                ] : []), true)))),
        React.createElement("div", { className: css.filterRow },
            React.createElement("span", { className: css.filterLabel }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.sourceSystem' })),
            React.createElement("div", { className: css.filterControl },
                React.createElement(Select, { fullWidth: true, "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.sourceSystem' }), value: list.sourceSystemFilter || '', dataOptions: sourceSystemOptions, onChange: function (e) {
                        return list.handleSourceSystemFilterChange(e.target.value || null);
                    } }))),
        React.createElement("div", { className: "".concat(css.filterRow, " ").concat(css.filterRowStacked) },
            React.createElement("span", { id: "authorities-filter-status-label", className: css.filterLabel }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.status' })),
            React.createElement(RadioButtonGroup, { className: css.filterInlineGroup, "aria-labelledby": "authorities-filter-status-label", value: list.statusFilter, onChange: function (e) {
                    return list.handleStatusFilterChange(e.target.value);
                } },
                React.createElement(RadioButton, { inline: true, label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.status.active' }), value: "active" }),
                React.createElement(RadioButton, { inline: true, label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.status.merged' }), value: "merged" }),
                React.createElement(RadioButton, { inline: true, label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.status.deleted' }), value: "deleted" }),
                React.createElement(RadioButton, { inline: true, label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.status.all' }), value: "all" }))),
        React.createElement("div", { className: "".concat(css.filterRow, " ").concat(css.filterRowStacked) },
            React.createElement("span", { className: css.filterLabel }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.createdDate' })),
            React.createElement("div", { className: css.filterDateControl },
                React.createElement(Datepicker, { label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.dateFrom' }), value: list.createdDateFrom, onChange: function (_e, formatted, dateString) { return list.setCreatedDateFrom(dateString || formatted); }, backendDateStandard: "YYYY-MM-DD" })),
            React.createElement("div", { className: css.filterDateControl },
                React.createElement(Datepicker, { label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.dateTo' }), value: list.createdDateTo, onChange: function (_e, formatted, dateString) { return list.setCreatedDateTo(dateString || formatted); }, backendDateStandard: "YYYY-MM-DD" })),
            list.createdDateValidationError && (React.createElement("div", { className: css.filterError },
                React.createElement(FormattedMessage, { id: list.createdDateValidationError })))),
        React.createElement("div", { className: "".concat(css.filterRow, " ").concat(css.filterRowStacked) },
            React.createElement("span", { className: css.filterLabel }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.updatedDate' })),
            React.createElement("div", { className: css.filterDateControl },
                React.createElement(Datepicker, { label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.dateFrom' }), value: list.updatedDateFrom, onChange: function (_e, formatted, dateString) { return list.setUpdatedDateFrom(dateString || formatted); }, backendDateStandard: "YYYY-MM-DD" })),
            React.createElement("div", { className: css.filterDateControl },
                React.createElement(Datepicker, { label: intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.dateTo' }), value: list.updatedDateTo, onChange: function (_e, formatted, dateString) { return list.setUpdatedDateTo(dateString || formatted); }, backendDateStandard: "YYYY-MM-DD" })),
            list.updatedDateValidationError && (React.createElement("div", { className: css.filterError },
                React.createElement(FormattedMessage, { id: list.updatedDateValidationError })))),
        React.createElement("div", { className: "".concat(css.filterRow, " ").concat(css.filterRowStacked) },
            React.createElement("span", { className: css.filterLabel }, intl.formatMessage({ id: 'ui-czna-authorities.validation.filter.title' })),
            React.createElement("div", { className: css.filterInlineGroup }, ['HAS_ERRORS', 'HAS_WARNINGS_ONLY', 'VALID', 'NOT_VALIDATED'].map(function (status) { return (React.createElement(Checkbox, { key: status, name: "validationStatus-".concat(status), label: intl.formatMessage({ id: "ui-czna-authorities.validation.status.".concat(status === 'HAS_ERRORS' ? 'hasErrors'
                        : status === 'HAS_WARNINGS_ONLY' ? 'hasWarningsOnly'
                            : status === 'VALID' ? 'valid'
                                : 'notValidated') }), checked: list.validationStatusFilter.includes(status), onChange: function () { return list.toggleValidationStatusFilter(status); } })); }))),
        (canSearchUsers || !!list.createdByUserId) && (React.createElement("div", { className: css.filterRow, "data-testid": "creator-filter" },
            React.createElement("span", { className: css.filterLabel }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.creator' })),
            React.createElement("div", { className: css.filterControl }, list.createdByUserId ? (React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0' } },
                React.createElement("span", null, creatorLabel),
                React.createElement(Button, { buttonStyle: "fieldControl", onClick: function () {
                        list.setCreatedByUserId('');
                        list.setCreatedByUserName('');
                    }, "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.authorities.filter.creator.clear' }) }, "\u00D7"))) : (React.createElement(CreatorAutocomplete, { onSelect: function (userId, displayName) {
                    list.setCreatedByUserId(userId);
                    list.setCreatedByUserName(displayName);
                } })))))));
    var columnMapping = useMemo(function () { return (__assign({ 
        // CZNA-1512 — "Stav", not "Validace": the cell carries the validation result and the
        // review stage of a record, and a proposal's own status.
        validation: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.status" }), authorityId: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.authorityId" }), headingValue: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.headingValue" }), 
        // CZNA-1529 — over the marker-only column "Typ autority" would break mid-word too.
        type: typeIconOnly ? (React.createElement("span", { title: intl.formatMessage({ id: 'ui-czna-authorities.authorities.column.type' }) },
            React.createElement("span", { "aria-hidden": "true" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.typeShort" })),
            React.createElement("span", { className: "sr-only" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.type" })))) : React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.type" }), author: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.author" }), updatedAt: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.updatedAt" }) }, (showMergedIntoColumn ? {
        mergedIntoAuthorityId: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.column.mergedInto" }),
    } : {}))); }, [showMergedIntoColumn, typeIconOnly, intl]);
    // The validation column is decorative (no server-side sort), so add it to
    // nonInteractiveHeaders alongside the existing non-sortable columns. CZNA-1441: neither is
    // "author" — the server sorts by no 040 $a.
    var nonInteractiveHeaders = showMergedIntoColumn
        ? ['validation', 'authorityId', 'author', 'mergedIntoAuthorityId']
        : ['validation', 'authorityId', 'author'];
    var selectedRowId = selectedProposalId !== null && selectedProposalId !== void 0 ? selectedProposalId : selectedId;
    var renderContent = function () {
        // CZNA-538 — order matters: the error branch has to come before the empty one.
        // It used to be absent entirely, so a failed query fell through to "nothing
        // matching your criteria" and blamed the user's filter for a server fault.
        if (list.error && list.items.length === 0 && fieldQueryError) {
            return (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
                React.createElement("div", { className: "padding-all-gutter", "data-testid": "authorities-field-query-error", role: "alert" },
                    React.createElement(Headline, { size: "medium", margin: "none" },
                        React.createElement(FormattedMessage, { id: fieldQueryError.kind === 'timeout'
                                ? 'ui-czna-authorities.fieldQuery.error.timeout.heading'
                                : 'ui-czna-authorities.fieldQuery.error.invalid.heading' })),
                    React.createElement("p", { style: { color: '#666', marginTop: '8px' } }, fieldQueryError.kind === 'timeout' ? (React.createElement(FormattedMessage, { id: "ui-czna-authorities.fieldQuery.error.timeout.subtext", values: { seconds: fieldQueryError.seconds } })) : fieldQueryError.message))));
        }
        if (list.error && list.items.length === 0) {
            return React.createElement(TableErrorState, { error: list.error, onRetry: list.refetch, testId: "authorities-error" });
        }
        // CZNA-628 — before loading and before empty, because neither is true: the request was
        // never issued (see `queryTooShort` in useRecordList). Falling through would show a
        // spinner that never resolves, or blame the filters for a query we declined to run.
        // CZNA-217 — the list is held back while the applied field query cannot be sent:
        // the catalog is still loading, failed to load, or the (deep-linked) text has errors
        // that the line marks. None of those is "no records match".
        if (list.fieldQueryBlocked) {
            if (fieldQueryCatalog.isError || fieldQueryLanguage) {
                return (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
                    React.createElement(Layout, { className: "padding-all-gutter", "data-testid": "authorities-field-query-blocked" },
                        React.createElement("p", { style: { color: '#666' } },
                            React.createElement(FormattedMessage, { id: fieldQueryCatalog.isError
                                    ? 'ui-czna-authorities.fieldQuery.catalogError'
                                    : 'ui-czna-authorities.fieldQuery.hasErrors' })))));
            }
            return React.createElement(TableLoadingSkeleton, { testId: "authorities-loading", columns: [2, 3, 9, 3, 3, 3] });
        }
        if (list.queryTooShort) {
            return (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
                React.createElement(Layout, { className: "padding-all-gutter", "data-testid": "authorities-query-too-short" },
                    React.createElement(Headline, { size: "medium", margin: "none" },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.search.tooShort.heading" })),
                    React.createElement("p", { style: { color: '#666', marginTop: '8px' } },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.search.tooShort.subtext", values: { min: list.minQueryWordRun } })))));
        }
        // `isLoading || isFetching`, not `isLoading` alone: react-query only reports
        // `isLoading` while a key has no cached data at all, so a re-run of an already
        // seen query with no rows fell into the empty branch while still in flight.
        if ((list.isLoading || list.isFetching) && list.items.length === 0) {
            return (React.createElement(TableLoadingSkeleton, { testId: "authorities-loading", columns: [2, 3, 9, 3, 3, 3] }));
        }
        if (list.items.length === 0 && !list.isLoading && !list.isFetching) {
            if (list.isDefaultFilters) {
                return (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
                    React.createElement(Layout, { className: "padding-all-gutter" },
                        React.createElement(Headline, { size: "medium", margin: "none" },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.empty.heading" })),
                        React.createElement("p", { style: { color: '#666', marginTop: '8px' } },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.empty.subtext" })),
                        canCreateProposal ? (React.createElement(Button, { buttonStyle: "primary", style: { marginTop: '16px' }, onClick: function () { return history.push('/czna-authorities/authorities/new'); }, "data-testid": "authorities-empty-create" },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.new" }))) : null)));
            }
            return (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent" },
                React.createElement(Layout, { className: "padding-all-gutter" },
                    React.createElement("p", { style: { color: '#666' } },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.noResults" })),
                    React.createElement(Button, { onClick: list.handleClearFilters, style: { marginTop: '16px' } },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.clearFilters" })))));
        }
        return (
        /* CZNA-538 — the overlay replaces MCL's own `loading` indicator, which is the
           dot spinner at the edge of the list this ticket is about. Passing both would
           say the same thing twice, in one visible place and one invisible one. */
        React.createElement(TableRefetchOverlay, { active: list.isFetching, testId: "authorities-refetching" },
            React.createElement("div", { ref: setListNode, "data-testid": "authorities-mcl-wrapper", style: { height: '100%' }, 
                // Focus is put here (never by Tab) when the row it was on is gone (CZNA-1529).
                tabIndex: -1 }, (listSize || typeof ResizeObserver === 'undefined') && (
            // @ts-expect-error - stripes MCL types require all entity keys but only visible columns are needed
            React.createElement(MultiColumnList, { key: showMergedIntoColumn ? 'with-merged-into' : 'active', autosize: typeof ResizeObserver === 'undefined' || undefined, width: listSize === null || listSize === void 0 ? void 0 : listSize.width, height: listSize === null || listSize === void 0 ? void 0 : listSize.height, virtualize: true, contentData: tableItems, 
                /* CZNA-533: MCL's paging input, not the user-facing count — see useRecordList.
                   CZNA-1191: in page coordinates, so "next" has to be answered explicitly. */
                totalCount: list.paginationTotalCount, pagingCanGoNext: list.paginationCanGoNext, pagingType: "prev-next", pagingOffset: list.pageOffset, pageAmount: list.pageSize, columnMapping: columnMapping, visibleColumns: visibleColumns, columnWidths: columnWidths, formatter: resultsFormatter, sortedColumn: list.sortColumn, sortDirection: list.sortDirection, onHeaderClick: list.handleSort, nonInteractiveHeaders: nonInteractiveHeaders, selectedRow: selectedRowId ? { id: selectedRowId } : undefined, onRowClick: handleRowClick, onNeedMoreData: function (_amount, offset) {
                    return list.fetchMoreData(offset);
                }, 
                // CZNA-1529 — every resize now re-measures the rows, and MCL would then scroll a
                // clicked row back to where it was measured, which in a virtualized list can be the
                // end of it (CZNA-1513). The scroll position already holds the row.
                itemToView: NO_ITEM_TO_VIEW })))));
    };
    var detailRecord = useRecordDetail(selectedId).record;
    var preferredHeading = (_g = detailRecord === null || detailRecord === void 0 ? void 0 : detailRecord.headings) === null || _g === void 0 ? void 0 : _g.find(function (h) { return h.headingType === 'PREFERRED'; });
    var paneDetailTitle = (preferredHeading === null || preferredHeading === void 0 ? void 0 : preferredHeading.headingValue)
        || intl.formatMessage({ id: 'ui-czna-authorities.authorities.detail.title' });
    var closeDetail = function () { return history.push(match.path); };
    // CZNA-1190 — ProposalDetailView closes itself after submit/publish/review and refreshes only
    // the proposal queries. Opened from its own workspace that was enough, because coming back
    // remounted this list; here the list never unmounts, so a row would keep its old status.
    var closeProposalDetail = function () {
        queryClient.invalidateQueries([RECORDS_QUERY_ROOT]);
        closeDetail();
    };
    // CZNA-1190 — the same ProposalDetailView the proposal workspaces and Ke kontrole render,
    // so its actions follow the existing permissions; only where it is shown changed.
    var selectedProposalRow = selectedProposalId
        ? list.items.find(function (item) { return item.id === selectedProposalId; })
        : undefined;
    // CZNA-778 — the detail brings its own Pane, so its actions can sit in the header.
    var detailPane = selectedProposalId ? (React.createElement(ProposalDetailView, { id: selectedProposalId, onClose: closeProposalDetail, paneProps: {
            id: 'authoritiesProposalDetailPane',
            defaultWidth: '44%',
            paneTitle: (selectedProposalRow === null || selectedProposalRow === void 0 ? void 0 : selectedProposalRow.headingValue)
                || intl.formatMessage({ id: 'ui-czna-authorities.proposals.title' }),
        } })) : selectedId ? (
    // CZNA-1456 — the record detail brings its own Pane too, for the same reason.
    React.createElement(RecordDetail, { id: selectedId, onClose: closeDetail, paneProps: {
            defaultWidth: '44%',
            paneTitle: paneDetailTitle,
            paneSub: detailRecord ? "".concat(intl.formatMessage({ id: "ui-czna-authorities.recordType.".concat(detailRecord.type) }), " \u00B7 ").concat((_h = recordDisplayId(detailRecord)) !== null && _h !== void 0 ? _h : '') : undefined,
        } })) : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchLayout, { list: list, searchPlaceholder: intl.formatMessage({ id: 'ui-czna-authorities.authorities.search.placeholder' }), paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.title" }), filterContent: filterContent, subNavigation: React.createElement(AuthorityWorkspaceNavigation, null), lastMenu: lastMenu, detailPane: detailPane, 
            // CZNA-1443 — on the left of the results header, next to the results it searches.
            // In the search pane it sat apart from the editor it opens; as a labelled button
            // in the header it squeezed the result count to nothing with a record detail open
            // (an icon leaves it 84 px at 1280 wide).
            headerSearch: (React.createElement(React.Fragment, null,
                React.createElement(PaneHeaderIconButton, { icon: "search", "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.fieldQuery.toggle' }), "aria-labelledby": "czna-field-query-toggle-tooltip-text", 
                    // IconButton renders `aria-expanded={false}` as no attribute; the string keeps "closed".
                    ariaExpanded: String(fieldQueryOpen), "aria-controls": "czna-field-query-editor", onClick: openFieldQuery, ref: fieldQueryOpenerRef, "data-testid": "field-query-toggle" }),
                React.createElement(Tooltip, { id: "czna-field-query-toggle-tooltip", text: intl.formatMessage({ id: 'ui-czna-authorities.fieldQuery.toggle' }), triggerRef: fieldQueryOpenerRef }))) },
            canRevalidate && React.createElement(RevalidationProgressBanner, null),
            !fieldQueryOpen && list.appliedFieldQueryText && (React.createElement("div", { className: css.fieldQueryChip, "data-testid": "field-query-chip" },
                React.createElement("span", { className: css.fieldQueryChipText },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.fieldQuery.applied" }),
                    ' ',
                    React.createElement("code", { "data-testid": "field-query-chip-text" }, list.appliedFieldQueryText),
                    list.appliedFieldQueryMatchCase && (React.createElement(React.Fragment, null,
                        ' ',
                        React.createElement("span", { "data-testid": "field-query-chip-match-case" },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.fieldQuery.appliedMatchCase" }))))),
                React.createElement(Button, { marginBottom0: true, onClick: openFieldQuery, buttonRef: fieldQueryEditRef, "data-testid": "field-query-edit" },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.fieldQuery.edit" })),
                React.createElement(IconButton, { icon: "times", onClick: removeFieldQuery, "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.fieldQuery.remove' }), "data-testid": "field-query-remove" }))),
            fieldQueryOpen && fieldQueryCatalog.isError && (React.createElement(MessageBanner, { type: "error" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.fieldQuery.catalogError" }))),
            fieldQueryOpen && fieldQueryLanguage && (React.createElement(FieldQueryLine, { language: fieldQueryLanguage, value: list.fieldQueryText, onChange: list.setFieldQueryText, matchCase: list.fieldQueryMatchCase, onMatchCaseChange: list.setFieldQueryMatchCase, onSubmit: list.submitFieldQuery, onClose: closeFieldQuery })),
            list.appliedIssueCode ? (React.createElement(MessageBanner, { type: "default", dismissible: true, onExited: list.clearIssueCode, "data-test-issue-code-chip": true },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.filter.issueCode", values: { code: list.appliedIssueCode } }))) : null,
            renderContent()),
        canImport && (React.createElement(ImportFileModal, { open: importOpen, onClose: function () { return setImportOpen(false); }, onImported: handleImported })),
        React.createElement(Callout, { ref: calloutRef })));
};
export default AuthoritiesList;
